var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPackageOutlined = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9789 3.49599L7.81016 0.1377C7.47511 -0.0464954 7.06893 -0.0456329 6.73468 0.139983L0.58024 3.52584C0.222263 3.7227 -0.000170184 4.09881 -0.000227688 4.50734L0.0139921 11.2039C0.0157846 11.6124 0.239813 11.9876 0.598622 12.1829L6.76738 15.5426C7.10242 15.7268 7.50861 15.7259 7.84286 15.5403L13.9973 12.1544C14.3553 11.9576 14.5777 11.5815 14.5778 11.1729L14.5636 4.47711C14.5625 4.06783 14.3384 3.69168 13.9789 3.49599ZM7.2745 1.1191L12.9063 4.18795L10.8243 5.33367L5.19178 2.26482L7.2745 1.1191ZM7.28758 7.2807L1.65578 4.21184L4.02664 2.90726L9.65844 5.97612L7.28758 7.2807ZM1.12153 5.19323L6.72948 8.24674L6.74224 14.2536L1.13428 11.2022L1.12153 5.19323ZM13.4575 11.1732L7.86253 14.2512L7.84978 8.24716L10.0878 7.01638L10.0931 9.51533C10.094 9.94653 10.5613 10.215 10.9343 9.99865C11.1074 9.89822 11.2138 9.71307 11.2134 9.51296L11.2067 6.40064L13.4447 5.16707L13.4575 11.1725L13.4575 11.1732Z",
    fill: "#1863DC"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPackageOutlined, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PackageOutlined.78270af0.svg";
export { ForwardRef as ReactComponent };